module.exports = __webpack_public_path__ + "static/media/artt.02d952d1.JPG";